import { render, staticRenderFns } from "./MdtRadioList.vue?vue&type=template&id=5542aedb&scoped=true"
import script from "./MdtRadioList.vue?vue&type=script&lang=js"
export * from "./MdtRadioList.vue?vue&type=script&lang=js"
import style0 from "./MdtRadioList.vue?vue&type=style&index=0&id=5542aedb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542aedb",
  null
  
)

export default component.exports